import React, { Fragment } from "react";

import Head from "layout/Head";

import CONTEXT from "./context";

import { Header, Logo, Title, Description } from "./layout";

import DownloadStarted from "./DownloadStarted";

const { downloadStarted, title, logo, description, description2 } = CONTEXT;

const LayoutComponent = (props) => {
  return (
    <Fragment>
      <Head
        title="UniFi | Designed for UniFi"
        description="Industry-leading user experience and value"
        image="https://www.ui.com/microsite/og-image.accessories-v2.jpg"
      />

      <Header>
        <Logo>
          <img src={logo} alt="" />
          <Title>{title}</Title>
        </Logo>

        <Description>{description}</Description>
        <Description>{description2}</Description>
      </Header>
      <DownloadStarted {...downloadStarted} />
    </Fragment>
  );
};

export default LayoutComponent;
